export default "/images/4b6e95583aa93bde48699e7aa2864788.avif";